import {DownloadOutlined} from "@ant-design/icons";
import {Button, message} from "antd";
import {useReviewsExportCSV} from "../../../react-query-hooks/reviews/get-reviews";

export function ReviewsExportCsv({isExportCsvDisabled}: {isExportCsvDisabled: boolean}) {
  const exportCsvQueryMutation = useReviewsExportCSV();
  const handleExportAsCSV = () => {
    exportCsvQueryMutation.mutate(undefined, {
      onSuccess: (data) => {
        message.success("File ready to be downloaded!");
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "coachli-reviews.csv");
        document.body.appendChild(link);
        link.click();
      },
    });
  };
  return (
    <div style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
      <Button
        onClick={handleExportAsCSV}
        disabled={isExportCsvDisabled}
        icon={<DownloadOutlined style={{fontSize: "1.6rem"}} />}
        type="text"
        size="small"
        loading={exportCsvQueryMutation.isLoading}
      >
        <span style={{textDecoration: "underline"}}>Export CSV</span>
      </Button>
    </div>
  );
}
